import { Box, Typography } from "@material-ui/core";
import { useLayoutEffect, useRef, useState } from "react";
import SequenceOverview from "../../Sequences/SequenceOverview/SequenceOverview.component";
import ShotsPageOverview from "../../Shots/ShotsPageOverview/ShotsPageOverview.component";
import Loader from "../../Utilities/Loader/Loader";
import SequencerMixVideoPlayer from "../PlayerView/SequencerMixVideoPlayer";
import {
  clampPlayerWrapperHeightPx,
  DATA_VIEW_MIN_PLAYER_WRAPPER_HEIGHT_PX,
  getDefaultPlayerWrapperHeightPx,
} from "./sequencerDataViewLayout";
import useDataViewStyles from "./SequencerMixDataView.styles";
import SequencerMixDataViewRightPanel from "./SequencerMixDataViewRightPanel";
import SequencerMixResizableDivider from "./SequencerMixResizableDivider";

const SequencerMixDataView = ({
  totalDuration,
  isVideosLoaded,
  currentTime,
  setCurrentTime,
  isVideoPlaying,
  sequencerDetails,
  projectId,
  currentUrlBatch,
  setCurrentUrlBatch,
  loadedUrls,
  shotsLineUp,
  seekToTime,
  setIsVideoPlaying,
  startedLoadingBatches,
  playerContainerRef,
  forceReloadBatch,
  setSelectedVersion,
  setScreenshot,
  canvasModal,
  registerVideoReset,
  setResetAll,
  isExportModalOpen,
  setIsExportModalOpen,
  isExporting,
  setIsExporting,
  shotsPageParams,
  setSeekToTime,
  sequenceId,
  selectedVersion,
  refreshCounter,
  setRefreshCounter,
  screenshot,
  setCanvasModal,
}) => {
  const classes = useDataViewStyles();
  const [playerHeightPx, setPlayerHeightPx] = useState(
    DATA_VIEW_MIN_PLAYER_WRAPPER_HEIGHT_PX,
  );
  const [viewMode, setViewMode] = useState({
    sequence: false,
    shots: true,
    seqId: sequencerDetails.sequences[0].id,
    shotId: null,
    seqName: sequencerDetails.sequences[0].code,
    shotName: null,
  });
  const leftColRef = useRef(null);
  const leftPanelRef = useRef(null);
  const rightColRef = useRef(null);
  const hasInitializedRef = useRef(false);

  useLayoutEffect(() => {
    const syncLayout = () => {
      const leftCol = leftColRef.current;
      const rightCol = rightColRef.current;
      if (!leftCol || !rightCol) return;

      const rightColHeight = rightCol.getBoundingClientRect().height;
      const leftColHeight = leftCol.getBoundingClientRect().height;

      if (!hasInitializedRef.current) {
        setPlayerHeightPx(
          getDefaultPlayerWrapperHeightPx(leftColHeight, rightColHeight),
        );
        hasInitializedRef.current = true;
        return;
      }

      setPlayerHeightPx((prev) =>
        clampPlayerWrapperHeightPx(prev, rightColHeight),
      );
    };

    syncLayout();
    window.addEventListener("resize", syncLayout);
    return () => window.removeEventListener("resize", syncLayout);
  }, []);

  return (
    <Box className={classes.root}>
      <Box ref={leftColRef} className={classes.leftCol}>
        <Box ref={leftPanelRef} className={classes.leftPanel}>
          <Box
            className={classes.playerSection}
          >
            <Box className={classes.playerSectionHeader}>
              <Typography color="#B1B5C9" style={{ fontSize: "12px" }}>{selectedVersion?.shotVersion?.name}</Typography>
            </Box>
            {isVideosLoaded ? (
              <Box style={{ height: `${playerHeightPx}px` }}>
                <SequencerMixVideoPlayer
                  setScreenshot={setScreenshot}
                  canvasModal={canvasModal}
                  embedded
                  currentTime={currentTime}
                  setCurrentTime={setCurrentTime}
                  isVideoPlaying={isVideoPlaying}
                  sequencerDetails={sequencerDetails}
                  projectId={projectId}
                  currentUrlBatch={currentUrlBatch}
                  setCurrentUrlBatch={setCurrentUrlBatch}
                  loadedUrls={loadedUrls}
                  orderedVideo={shotsLineUp}
                  seekToTime={seekToTime}
                  setIsVideoPlaying={setIsVideoPlaying}
                  startedLoadingBatches={startedLoadingBatches}
                  playerContainerRef={playerContainerRef}
                  forceReloadBatch={forceReloadBatch}
                  setSelectedVersion={setSelectedVersion}
                  selectedVersion={selectedVersion}
                  registerVideoReset={registerVideoReset}
                  setResetAll={setResetAll}
                  isExportModalOpen={isExportModalOpen}
                  setIsExportModalOpen={setIsExportModalOpen}
                  isExporting={isExporting}
                  setIsExporting={setIsExporting}
                  setSeekToTime={setSeekToTime}
                  totalDuration={totalDuration}
                />
              </Box>
            ) : (
              <Loader />
            )}
          </Box>
          <SequencerMixResizableDivider
            panelRef={leftPanelRef}
            scrollContainerRef={leftColRef}
            rightColRef={rightColRef}
            onHeightChange={setPlayerHeightPx}
          />
          <Box className={classes.tableSection}>
            {viewMode.sequence && (
              <SequenceOverview embedded={true} params={{ projectId }} setViewMode={setViewMode} />
            )}
            {viewMode.shots && (
              <ShotsPageOverview params={{ projectId, sid: sequenceId }} embedded={true} setViewMode={setViewMode} viewMode={viewMode} />
            )}
          </Box>
        </Box>
      </Box>
      <Box ref={rightColRef} className={classes.rightCol}>
        <SequencerMixDataViewRightPanel
          selectedVersion={selectedVersion}
          currentTime={currentTime}
          setCurrentTime={setCurrentTime}
          setSeekToTime={setSeekToTime}
          isVideoPlaying={isVideoPlaying}
          refreshCounter={refreshCounter}
          setRefreshCounter={setRefreshCounter}
          projectId={projectId}
          screenshot={screenshot}
          setScreenshot={setScreenshot}
          canvasModal={canvasModal}
          setCanvasModal={setCanvasModal}
          sequencerDetails={sequencerDetails}
          shotsLineUp={shotsLineUp}
        />
      </Box>
    </Box>
  );
};

export default SequencerMixDataView;
